import { Box, Typography } from '@mui/material'
import React from 'react'
import LogoIcon from '../../../assets/images/logo/finalLogo.svg'
import LogoImage from '../../../assets/images/logo/logo-black.png';

function ContactText() {
  return (
    <Box sx={{ width: { mdlg: '35%', xs: '90%' }, bgcolor: '#fff', gap: 3, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} >
      <Box component="img" src={LogoIcon} sx={{ width: '18vw', height: '35vh' }} />
      <Box component="img" src={LogoImage} sx={{ width: '14rem', height: '6rem' }} />
      <Typography sx={{ textAlign: 'center', fontFamily: '"Montserrat", sans-serif', }} >We bridge the gap between Data and Intelligence</Typography>
    </Box>
  )
}

export default ContactText
